import Vue from 'vue/dist/vue.js'
import axios from 'axios'
import {
  CATEGORY_LIST_API, FEATURED_PRODUCT_API,
  SUBCATEGORY_LIST_API,
  updateMetaTitle,
} from './consts'

export default function() {

  new Vue({
    el: '.js-featured-products-slider',
    name: 'Featured Products Slider',
    data() {
      return {
        products: []
      };
    },
    async mounted() {
      const response = await axios.get(FEATURED_PRODUCT_API)
      this.products = response.data.data;
    },
  });
}
